import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

export const ZoomControl = ({ onChange }) => {
  const { t } = useTranslation();
  const handleZoom = useCallback(
    ({ currentTarget: { value } }) => {
      onChange({ [value]: true });
    },
    [onChange]
  );

  return (
    <>
      <Button
        data-testid="ol-control-zoom-in"
        title={t('components.zoomIn', 'Zoom In')}
        value="zoomIn"
        onClick={handleZoom}
      >
        <ZoomInOutlined />
      </Button>
      <Button
        data-testid="ol-control-zoom-out"
        title={t('components.zoomOut', 'Zoom Out')}
        value="zoomOut"
        onClick={handleZoom}
      >
        <ZoomOutOutlined />
      </Button>
    </>
  );
};
